import React from 'react';
import { InfoEstadoDataType } from './DataType';

type InfoProps = {
    info: InfoEstadoDataType;
}


const Info: React.FC<InfoProps> = ({info}) => {
    return (
        <>
        <div className="info" style={{width:"auto", height:"auto", position:'absolute', top:'10px', right:'10px', padding:'10px', zIndex:'20000'}}>
        {info &&(            
            <>
            <h3>Testimoniantes por Estados</h3>
            {info.idEstado != 0 ?(
                <>
                <h3 className='mb-0'>{info.nombre}</h3>
                <p className='fs-5 mb-1'><b>{info.cantidad} </b> Entrevistas realizadas</p>
                <hr className='m-1' />
                {info.municipios.map((child: any, index) => (
                    <p key={index} className='fs-5 mb-1'><b>{child.cantidad} </b> {child.nombre}</p>
                ))}
                </>
            ) :(
                <>
                <p className='fs-5'>De click a un estado</p>
                </>
            )}
            </>
        )}
        </div>
        </>        
    );
}

export default Info;